var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 -960 960 960"}},[_c('path',{attrs:{"d":"M378-246 154-470l43-43 181 181 384-384 43 43-427 427Z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }